// lazyComponents.js
import React from "react";

// Lazy loading components
export const PaymentReceipt = React.lazy(
  () => import("./components/Payments/PaymentReceipt"),
);
export const PaymentsList = React.lazy(
  () => import("./components/Payments/PaymentsList"),
);
export const PaymentPage = React.lazy(
  () => import("./components/Payment/PaymentPage"),
);
export const Invoice = React.lazy(() => import("./components/Invoice/Invoice"));
export const Invoices = React.lazy(
  () => import("./components/Invoices/Invoices"),
);
export const InvoiceDetails = React.lazy(
  () => import("./components/InvoiceDetails/InvoiceDetails"),
);
export const ClientList = React.lazy(
  () => import("./components/Clients/ClientList"),
);
export const Login = React.lazy(() => import("./components/Login/Login"));
export const Dashboard = React.lazy(
  () => import("./components/Dashboard/Dashboard"),
);
export const ProtectedDashboard = React.lazy(
  () => import("./components/Dashboard/ProtectedDashboard"),
);
export const Settings = React.lazy(
  () => import("./components/Settings/Settings"),
);
export const SettingsHome = React.lazy(
  () => import("./components/Settings/SettingsHome"),
);
export const ZatcaIntegrationSettings = React.lazy(
  () => import("./components/Settings/ZatcaIntegrationSettings"),
);
export const ProfileSettings = React.lazy(
  () => import("./components/Profile/Settings"),
);
export const Forgot = React.lazy(() => import("./components/Password/Forgot"));
export const Reset = React.lazy(() => import("./components/Password/Reset"));
export const AddCategory = React.lazy(
  () => import("./components/Categories/AddCategory"),
);
export const Categories = React.lazy(
  () => import("./components/Categories/Categories"),
);
export const Items = React.lazy(
  () => import("./components/Inventory/Items/Items"),
);
export const AddItem = React.lazy(
  () => import("./components/Inventory/Items/AddItem"),
);
export const BarcodeSettings = React.lazy(
  () => import("./components/BarcodeSettings/BarcodeSettings"),
);
export const POS = React.lazy(
  () => import("./components/POS/ModernPOSLanding"),
);
export const LegacyPOS = React.lazy(() => import("./components/POS/pos"));
export const ModernPOSTerminal = React.lazy(
  () => import("./components/ModernPOS/ModernPOSTerminal"),
);
export const Receipt = React.lazy(() => import("./components/POS/receipt"));
export const Download = React.lazy(
  () => import("./components/Download/Download"),
);
export const ProfitCentersList = React.lazy(
  () => import("./components/ProfitCenters/ProfitCentersList"),
);
export const UserGroups = React.lazy(
  () => import("./components/UserGroups/UserGroups"),
);
export const AddUserGroup = React.lazy(
  () => import("./components/UserGroups/AddUserGroup"),
);
export const Users = React.lazy(() => import("./components/Users/Users"));
export const EmployeeList = React.lazy(
  () => import("./components/Employees/EmployeeList"),
);
export const RentalList = React.lazy(
  () => import("./components/Rental/RentalList"),
);
export const RentalForm = React.lazy(
  () => import("./components/Rental/RentalForm"),
);
export const RentalHome = React.lazy(
  () => import("./components/Rental/RentalHome"),
);
export const BuildingsList = React.lazy(
  () => import("./components/Building/BuildingsList"),
);
export const BuildingDetails = React.lazy(
  () => import("./components/Building/BuildingDetails"),
);

export const Accounts = React.lazy(
  () => import("./components/Accounts/Accounts"),
);
export const Transaction = React.lazy(
  () => import("./components/Transaction/Transaction"),
);
export const Transactions = React.lazy(
  () => import("./components/Transaction/Transactions"),
);

export const TaxSettings = React.lazy(
  () => import("./components/TaxSettings/TaxSettings"),
);

export const AccountingHome = React.lazy(
  () => import("./components/Home/AccountingHome"),
);

export const AccountingReportsPage = React.lazy(
  () => import("./components/Home/AccountingReportsPage"),
);

export const HRHomePage = React.lazy(
  () => import("./components/Home/HRHomePage"),
);

export const Letter = React.lazy(() => import("./components/Letters/Letter"));
export const LettersHome = React.lazy(
  () => import("./components/Letters/LettersHome"),
);

export const LetterViewer = React.lazy(
  () => import("./components/Letters/LetterViewer"),
);

export const LettersList = React.lazy(
  () => import("./components/Letters/LettersList"),
);

export const TemplateManager = React.lazy(
  () => import("./components/Letters/Templates/TemplateManager"),
);

export const TemplateLibrary = React.lazy(
  () => import("./components/Letters/Templates/TemplateLibrary"),
);

export const ApprovalDashboard = React.lazy(
  () => import("./components/Letters/Approval/ApprovalDashboard"),
);

export const ApprovalQueue = React.lazy(
  () => import("./components/Letters/Approval/ApprovalQueue"),
);

export const LetterInbox = React.lazy(
  () => import("./components/Letters/Collaboration/LetterInbox"),
);

export const LetterOutbox = React.lazy(
  () => import("./components/Letters/Collaboration/LetterOutbox"),
);
export const Costcenters = React.lazy(
  () => import("./components/Costcenters/Costcenters"),
);

export const TrialBalance = React.lazy(
  () => import("./components/TrialBalance/TrialBalance"),
);

export const BalanceSheet = React.lazy(
  () => import("./components/BalanceSheet/BalanceSheet"),
);

export const IncomeStatement = React.lazy(
  () => import("./components/IncomeStatement/IncomeStatement"),
);

export const CashFlow = React.lazy(
  () => import("./components/CashFlow/CashFlow"),
);

export const ComprehensiveIncome = React.lazy(
  () => import("./components/ComprehensiveIncome/ComprehensiveIncome"),
);

export const StockholdersEquity = React.lazy(
  () => import("./components/StockholdersEquity/StockholdersEquity"),
);

export const GeneralLedger = React.lazy(
  () => import("./components/GeneralLedger/GeneralLedger"),
);

export const AgingReport = React.lazy(
  () => import("./components/AgingReport/AgingReport"),
);

export const AccountStatement = React.lazy(
  () => import("./components/AccountStatement/AccountStatement"),
);

export const VATReport = React.lazy(
  () => import("./components/VATReport/VATReport"),
);

export const ProjectProfitability = React.lazy(
  () => import("./components/ProjectProfitability/ProjectProfitability"),
);

export const PurchaseInvoice = React.lazy(
  () => import("./components/Purchase/Purchase"),
);

export const PurchaseInvoiceDetails = React.lazy(
  () => import("./components/Purchase/PurchaseDetails"),
);
export const PurchaseInvoices = React.lazy(
  () => import("./components/Purchase/PurchaseInvoices"),
);

export const GeneratePayroll = React.lazy(
  () => import("./components/Payrolls/GeneratePayroll"),
);
export const PayrollList = React.lazy(
  () => import("./components/Payrolls/PayrollList"),
);

export const PayrollsHome = React.lazy(
  () => import("./components/Payrolls/PayrollsHome"),
);

export const BulkGeneratePayroll = React.lazy(
  () => import("./components/Payrolls/BulkGeneratePayroll"),
);

export const PayrollAnalytics = React.lazy(
  () => import("./components/Payrolls/PayrollAnalytics"),
);

export const PayrollPayments = React.lazy(
  () => import("./components/Payrolls/PayrollPayments"),
);

export const AssetsList = React.lazy(
  () => import("./components/Assets/AssetsList"),
);
export const AssetsForm = React.lazy(
  () => import("./components/Assets/AssetsForm"),
);

export const AttendanceList = React.lazy(
  () => import("./components/Attendance/AttendanceList"),
);

export const TimeTracking = React.lazy(
  () => import("./components/Attendance/TimeTracking"),
);

export const AttendanceReports = React.lazy(
  () => import("./components/Attendance/AttendanceReports"),
);

export const RecordAttendance = React.lazy(
  () => import("./components/Attendance/RecordAttendance"),
);

// Modern Attendance Components
export const AttendanceHome = React.lazy(
  () => import("./components/Attendance/AttendanceHome"),
);

export const ModernCheckInOut = React.lazy(
  () => import("./components/Attendance/ModernCheckInOut"),
);

export const ShiftManagement = React.lazy(
  () => import("./components/Attendance/ShiftManagement"),
);

export const HolidayManagement = React.lazy(
  () => import("./components/Attendance/HolidayManagement"),
);

export const AttendanceSettings = React.lazy(
  () => import("./components/Settings/AttendanceSettings"),
);
export const SMSProvider = React.lazy(
  () => import("./components/SMSPoviders/SMSProvider"),
);
export const CommunicationCenter = React.lazy(
  () => import("./components/CommunicationCenter/CommunicationCenter"),
);
export const BarcodePrint = React.lazy(
  () => import("./components/BarcodePrint/BarcodePrint"),
);

export const QRCodeGenerator = React.lazy(
  () => import("./components/QRCodeGenerator/QRCodeGenerator"),
);

export const QRCodeForm = React.lazy(
  () => import("./components/QRCodeGenerator/QRCodeForm"),
);

export const PublicQRCode = React.lazy(
  () => import("./components/QRCodeGenerator/PublicQRCode"),
);

export const AppHomePage = React.lazy(
  () => import("./components/AppHomePage/AppHomePage"),
);

export const ProjectsList = React.lazy(
  () => import("./components/Projects/ProjectsList"),
);
export const AccountingSettings = React.lazy(
  () => import("./components/AccountingSettings/AccountingSettings"),
);

export const NotificationsList = React.lazy(
  () => import("./components/Notifications/NotificationsList"),
);

export const Vouchers = React.lazy(
  () => import("./components/Vouchers/vouchers"),
);

export const Coupons = React.lazy(() => import("./components/coupons/Coupons"));

export const CreateCoupons = React.lazy(
  () => import("./components/coupons/CreateCoupons"),
);

export const Properties = React.lazy(
  () => import("./components/Properties/Properties"),
);
export const AddProperties = React.lazy(
  () => import("./components/Properties/PropertyForm"),
);

export const EditProperties = React.lazy(
  () => import("./components/Properties/PropertyForm"),
);

export const viewProperties = React.lazy(
  () => import("./components/Properties/PropertyViewer"),
);

// Clinic Management Components
export const ClinicManagementHome = React.lazy(
  () => import("./components/ClinicManagement/ClinicManagementHome"),
);
export const DoctorList = React.lazy(
  () => import("./components/ClinicManagement/Doctors/DoctorList"),
);
export const DoctorDetail = React.lazy(
  () => import("./components/ClinicManagement/Doctors/DoctorDetail"),
);
export const DoctorForm = React.lazy(
  () => import("./components/ClinicManagement/Doctors/DoctorForm"),
);
export const PatientList = React.lazy(
  () => import("./components/ClinicManagement/Patient/PatientList"),
);
export const PatientDetail = React.lazy(
  () => import("./components/ClinicManagement/Patient/PatientDetail"),
);
export const PatientForm = React.lazy(
  () => import("./components/ClinicManagement/Patient/PatientForm"),
);
export const AppointmentList = React.lazy(
  () => import("./components/ClinicManagement/Appointment/AppointmentList"),
);
export const AppointmentDetail = React.lazy(
  () => import("./components/ClinicManagement/Appointment/AppointmentDetail"),
);

export const AppointmentForm = React.lazy(
  () => import("./components/ClinicManagement/Appointment/AppointmentForm"),
);
export const LabResultList = React.lazy(
  () => import("./components/ClinicManagement/LabResult/LabResultList"),
);
export const LabResultDetail = React.lazy(
  () => import("./components/ClinicManagement/LabResult/LabResultDetail"),
);
export const LabResultForm = React.lazy(
  () => import("./components/ClinicManagement/LabResult/LabResultForm"),
);
export const LabTestList = React.lazy(
  () => import("./components/ClinicManagement/LabTest/LabTestList"),
);
export const LabTestDetail = React.lazy(
  () => import("./components/ClinicManagement/LabTest/LabTestDetail"),
);
export const LabTestForm = React.lazy(
  () => import("./components/ClinicManagement/LabTest/LabTestForm"),
);

export const MedicalRecordList = React.lazy(
  () => import("./components/ClinicManagement/MedicalRecord/MedicalRecordList"),
);
export const MedicalRecordDetail = React.lazy(
  () =>
    import("./components/ClinicManagement/MedicalRecord/MedicalRecordDetail"),
);
export const MedicalRecordForm = React.lazy(
  () => import("./components/ClinicManagement/MedicalRecord/MedicalRecordForm"),
);

export const PrescriptionList = React.lazy(
  () => import("./components/ClinicManagement/Prescription/PrescriptionList"),
);
export const PrescriptionDetail = React.lazy(
  () => import("./components/ClinicManagement/Prescription/PrescriptionDetail"),
);
export const PrescriptionForm = React.lazy(
  () => import("./components/ClinicManagement/Prescription/PrescriptionForm"),
);

export const MedicationList = React.lazy(
  () => import("./components/ClinicManagement/Medication/MedicationList"),
);
export const MedicationDetail = React.lazy(
  () => import("./components/ClinicManagement/Medication/MedicationDetail"),
);
export const MedicationForm = React.lazy(
  () => import("./components/ClinicManagement/Medication/MedicationForm"),
);

export const Messaging = React.lazy(
  () => import("./components/Messaging/Messaging"),
);

export const Inventory = React.lazy(
  () => import("./components/Inventory/Inventory"),
);
export const InventoryHome = React.lazy(
  () => import("./components/Inventory/InventoryHome"),
);
export const InventoryDetail = React.lazy(
  () => import("./components/Inventory/InventoryDetail"),
);

export const ManufacturingHome = React.lazy(
  () => import("./components/Manufacturing/ManufacturingHome"),
);
export const ManufacturingBoms = React.lazy(
  () => import("./components/Manufacturing/BomList"),
);
export const ManufacturingWorkCenters = React.lazy(
  () => import("./components/Manufacturing/WorkCenterList"),
);
export const ManufacturingRoutings = React.lazy(
  () => import("./components/Manufacturing/RoutingList"),
);
export const ManufacturingWorkOrders = React.lazy(
  () => import("./components/Manufacturing/WorkOrderList"),
);
export const ManufacturingProductionPlans = React.lazy(
  () => import("./components/Manufacturing/ProductionPlanList"),
);
export const ManufacturingQuality = React.lazy(
  () => import("./components/Manufacturing/QualityList"),
);
export const ManufacturingSubcontracting = React.lazy(
  () => import("./components/Manufacturing/SubcontractOrderList"),
);
export const ManufacturingMaintenance = React.lazy(
  () => import("./components/Manufacturing/MaintenanceRequestList"),
);
export const ManufacturingReports = React.lazy(
  () => import("./components/Manufacturing/ManufacturingReports"),
);
export const ManufacturingSettings = React.lazy(
  () => import("./components/Manufacturing/ManufacturingSettings"),
);

export const WarehouseList = React.lazy(
  () => import("./components/Inventory/WarehouseList"),
);

export const UnitOfMeasureList = React.lazy(
  () => import("./components/Inventory/UnitOfMeasureList"),
);

export const InventoryAdjustments = React.lazy(
  () => import("./components/Inventory/InventoryAdjustments"),
);

export const AddInventoryAdjustment = React.lazy(
  () => import("./components/Inventory/AddInventoryAdjustment"),
);

export const InventoryTransactions = React.lazy(
  () => import("./components/Inventory/InventoryTransactions"),
);

export const InventoryTransfers = React.lazy(
  () => import("./components/Inventory/InventoryTransfers"),
);

export const InventoryAlerts = React.lazy(
  () => import("./components/Inventory/InventoryAlerts"),
);

export const InventoryReports = React.lazy(
  () => import("./components/Inventory/InventoryReports"),
);

export const InventorySearch = React.lazy(
  () => import("./components/Inventory/InventorySearch"),
);

export const InventorySettings = React.lazy(
  () => import("./components/Inventory/InventorySettings"),
);

export const InventoryTransfer = React.lazy(
  () => import("./components/Inventory/Transfer"),
);

export const ExcelImportExportPage = React.lazy(
  () => import("./components/ExcelImportExport/ExcelImportExportPage"),
);

export const ExcelWorkbooksPage = React.lazy(
  () => import("./components/ExcelWorkbooks/ExcelWorkbooksPage"),
);

export const Units = React.lazy(
  () => import("./components/Inventory/UnitOfMeasureList"),
);

export const JournalsList = React.lazy(
  () => import("./components/Journals/JournalsList"),
);

export const JournalDetails = React.lazy(
  () => import("./components/Journals/JournalDetails"),
);

export const JournalEntryDetailsPage = React.lazy(
  () => import("./components/Journals/JournalEntryDetailsPage"),
);

export const JournalEntryDetails = React.lazy(
  () => import("./components/Journals/JournalEntryDetails"),
);

export const JournalReport = React.lazy(
  () => import("./components/Journals/JournalReport"),
);

export const TrialBalanceReport = React.lazy(
  () => import("./components/Journals/TrialBalanceReport"),
);

export const Poslist = React.lazy(
  () => import("./components/PosSettings/Poslist"),
);

export const AssetsViewer = React.lazy(
  () => import("./components/Assets/AssetsViewer"),
);

// Subscription Management Components
export const MySubscription = React.lazy(
  () => import("./components/Subscription/MySubscription"),
);

export const MyBilling = React.lazy(
  () => import("./components/Subscription/MyBilling"),
);

// Construction Management Components
export const ConstructionProjectsList = React.lazy(
  () => import("./components/Construction/ConstructionProjectsList"),
);

export const ConstructionProjectForm = React.lazy(
  () => import("./components/Construction/ConstructionProjectForm"),
);

export const ConstructionProjectDashboard = React.lazy(
  () => import("./components/Construction/ConstructionProjectDashboard"),
);

export const BOQList = React.lazy(
  () => import("./components/Construction/BOQList"),
);

export const BOQForm = React.lazy(
  () => import("./components/Construction/BOQForm"),
);

export const ProgressBillingList = React.lazy(
  () => import("./components/Construction/ProgressBillingList"),
);

export const SitesList = React.lazy(
  () => import("./components/Construction/SitesList"),
);

export const DailyReportsList = React.lazy(
  () => import("./components/Construction/DailyReportsList"),
);

export const SubcontractorsList = React.lazy(
  () => import("./components/Construction/SubcontractorsList"),
);

export const MaterialRequestsList = React.lazy(
  () => import("./components/Construction/MaterialRequestsList"),
);

export const ConstructionReports = React.lazy(
  () => import("./components/Construction/ConstructionReports"),
);

export const ProjectBudget = React.lazy(
  () => import("./components/Construction/ProjectBudget"),
);

export const ProjectExpenses = React.lazy(
  () => import("./components/Construction/ProjectExpenses"),
);

export const FinancialReport = React.lazy(
  () => import("./components/Construction/FinancialReport"),
);

export const ProgressReport = React.lazy(
  () => import("./components/Construction/ProgressReport"),
);

export const ScheduleReport = React.lazy(
  () => import("./components/Construction/ScheduleReport"),
);

export const ResourceReport = React.lazy(
  () => import("./components/Construction/ResourceReport"),
);

export const MaterialReport = React.lazy(
  () => import("./components/Construction/MaterialReport"),
);

export const OverallAnalytics = React.lazy(
  () => import("./components/Construction/OverallAnalytics"),
);

// Law Firm Management Components
export const LawFirmDashboard = React.lazy(
  () => import("./components/LawFirm/LawFirmDashboard"),
);
export const CaseList = React.lazy(
  () => import("./components/LawFirm/CaseList"),
);
export const CaseDetail = React.lazy(
  () => import("./components/LawFirm/CaseDetail"),
);
export const CaseForm = React.lazy(
  () => import("./components/LawFirm/CaseForm"),
);
export const TimeEntryList = React.lazy(
  () => import("./components/LawFirm/TimeEntryList"),
);
export const TimeEntryForm = React.lazy(
  () => import("./components/LawFirm/TimeEntryForm"),
);
export const TaskList = React.lazy(
  () => import("./components/LawFirm/TaskList"),
);
export const TaskForm = React.lazy(
  () => import("./components/LawFirm/TaskForm"),
);
export const BillingDashboard = React.lazy(
  () => import("./components/LawFirm/BillingDashboard"),
);
export const ExpenseList = React.lazy(
  () => import("./components/LawFirm/ExpenseList"),
);
export const ExpenseForm = React.lazy(
  () => import("./components/LawFirm/ExpenseForm"),
);
export const ReportsDashboard = React.lazy(
  () => import("./components/LawFirm/ReportsDashboard"),
);
export const LawFirmFinancialReport = React.lazy(
  () => import("./components/LawFirm/FinancialReport"),
);
export const TimeUtilizationReport = React.lazy(
  () => import("./components/LawFirm/TimeUtilizationReport"),
);
export const AttorneyPerformanceReport = React.lazy(
  () => import("./components/LawFirm/AttorneyPerformanceReport"),
);
export const ClientManagement = React.lazy(
  () => import("./components/LawFirm/ClientManagement"),
);
export const TrustAccountDashboard = React.lazy(
  () => import("./components/LawFirm/TrustAccountDashboard"),
);
export const DocumentManagement = React.lazy(
  () => import("./components/LawFirm/DocumentManagement"),
);
export const MatterManagement = React.lazy(
  () => import("./components/LawFirm/MatterManagement"),
);

export const CourtCalendar = React.lazy(
  () => import("./components/LawFirm/CourtCalendar"),
);
export const ConflictChecker = React.lazy(
  () => import("./components/LawFirm/ConflictChecker"),
);
export const ClientPortal = React.lazy(
  () => import("./components/ClientPortal/LawFirmClientPortal"),
);
export const ClientLogin = React.lazy(
  () => import("./components/ClientPortal/ClientLogin"),
);
export const ClientPortalHome = React.lazy(
  () => import("./components/ClientPortal/ClientPortalHome"),
);
export const ClientProfile = React.lazy(
  () => import("./components/ClientPortal/ClientProfile"),
);
export const ClientBillingReport = React.lazy(
  () => import("./components/LawFirm/ClientBillingReport"),
);
export const CaseProfitabilityReport = React.lazy(
  () => import("./components/LawFirm/CaseProfitabilityReport"),
);
export const PracticeAreaReport = React.lazy(
  () => import("./components/LawFirm/PracticeAreaReport"),
);
export const RealizationRateReport = React.lazy(
  () => import("./components/LawFirm/RealizationRateReport"),
);
export const CustomReport = React.lazy(
  () => import("./components/LawFirm/CustomReport"),
);

export const TodoApp = React.lazy(() => import("./components/TodoApp/TodoApp"));

// Inventory Orders
export const InventoryOrders = React.lazy(
  () => import("./components/Inventory/InventoryOrders"),
);

// Credit / Debit Notes
export const CreditDebitNoteList = React.lazy(
  () => import("./components/CreditDebitNote/CreditDebitNoteList"),
);
export const AddCreditDebitNote = React.lazy(
  () => import("./components/CreditDebitNote/AddCreditDebitNote"),
);
export const CreditDebitNoteDetails = React.lazy(
  () => import("./components/CreditDebitNote/CreditDebitNoteDetails"),
);
export const WorkflowSettings = React.lazy(
  () => import("./components/Workflow/WorkflowSettings/WorkflowSettings"),
);
export const WorkflowInbox = React.lazy(
  () => import("./components/Workflow/WorkflowInbox/WorkflowInbox"),
);
